import { render } from "./Recruit.vue?vue&type=template&id=d8f5aebe&ts=true"
import script from "./Recruit.vue?vue&type=script&lang=ts"
export * from "./Recruit.vue?vue&type=script&lang=ts"

import "./Recruit.vue?vue&type=style&index=0&id=d8f5aebe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__